<template>
  <div class="rui-panel">
    <div v-if="resize === 'left'" class="rui-panel__resizer rui-panel__resizer--left" @mousedown="initDrag" />

    <div ref="wrapper" class="rui-panel__wrapper">
      <div class="rui-panel__content">
        <slot />
      </div>
    </div>

    <div v-if="resize === 'right'" class="rui-panel__resizer rui-panel__resizer--right" @mousedown="initDrag" />
  </div>
</template>

<script>
const resizeSides = ['left', 'right']

/**
 * Resizable side panel
 *
 * @preset Default { "slots": { "default": "Lorem ipsum dolor sit amet, consectetur adipisicing elit." } }
 */
export default {
  name: 'RuiPanel',
  props: {
    /**
     * Whether the panel is resizable on the given side
     *
     * @values left, right
     */
    resize: { required: false, type: String, default: null, validator: v => resizeSides.includes(v) },
  },
  data () {
    return {
      // Used to resize the panel
      resizeX: null,
      resizeStartWidth: null,
    }
  },
  methods: {
    initDrag (event) {
      event.preventDefault()
      this.resizeX = event.clientX
      this.resizeStartWidth = parseInt(document.defaultView.getComputedStyle(this.$refs.wrapper).width, 10)
      document.documentElement.addEventListener('mousemove', this.doResize, false)
      document.documentElement.addEventListener('mouseup', this.stopResize, false)
    },
    doResize (event) {
      let value
      if (this.resize === 'left') value = this.resizeStartWidth - event.clientX + this.resizeX // + 12
      else value = this.resizeStartWidth + event.clientX - this.resizeX

      this.$refs.wrapper.style.width = value + 'px'
    },
    stopResize () {
      document.documentElement.removeEventListener('mousemove', this.doResize, false)
      document.documentElement.removeEventListener('mouseup', this.stopResize, false)
    },
  },
}
</script>
